<div id="best-practices-home" class="watermark py-5">
  <div class="container-fluid px-lg-5">

    <!-- Page Heading -->
    <h2 class="title text-center">Best Practices of the College</h2>

    <!-- Quote -->
    <p class="bp-quote text-center mt-3 mb-4">"Practicing with purpose is the key to progress."</p>

    <!-- Intro -->
    <p class="bp-intro">
      Our college is dedicated to fostering holistic development and community engagement through a variety of best
      practices. These initiatives are designed to promote physical health, moral integrity, social responsibility, and
      professional competence among our students.
    </p>

    <!-- Practice Items -->
    <div class="bp-list mt-4">

      <!-- 1 -->
      <div class="bp-item">
        <h5 class="bp-item-title">Morning Health Exercises: <span class="bp-item-subtitle">"Start Strong, Stay Healthy"</span></h5>
        <p>We begin each day with morning health exercises, ensuring that our students maintain physical fitness and
          mental well-being. This practice not only enhances their concentration and energy levels but also instils the
          importance of a healthy lifestyle.</p>
      </div>

      <!-- 2 -->
      <div class="bp-item">
        <h5 class="bp-item-title">Moral Education Classes: <span class="bp-item-subtitle">"Building Integrity, Shaping Futures"</span></h5>
        <p>Daily classes on Moral Education are integral to our curriculum. These sessions aim to build a strong ethical
          foundation in our students, guiding them to become responsible and conscientious citizens.</p>
      </div>

      <!-- 3 -->
      <div class="bp-item">
        <h5 class="bp-item-title">Community Services: <span class="bp-item-subtitle">"Serve, Support, Succeed"</span></h5>
        <p>Our commitment to community service is demonstrated through various initiatives:</p>
        <ul class="bp-sublist">
          <li>
            <strong>Blood Donation Drives: <em>"Give Blood, Save Lives"</em></strong> —
            Regularly organized to contribute to local blood banks and assist in saving lives.
          </li>
          <li>
            <strong>Cleanliness Campaigns: <em>"Clean Campus, Green Future"</em></strong> —
            Active participation in maintaining cleanliness in and around the college campus.
          </li>
          <li>
            <strong>Donations: <em>"Sharing is Caring"</em></strong> —
            Collecting and donating clothes, books, and essential goods to the needy and underprivileged, including
            support for essential items for needy brides.
          </li>
        </ul>
      </div>

      <!-- 4 -->
      <div class="bp-item">
        <h5 class="bp-item-title">Remedial and Job-Oriented Courses: <span class="bp-item-subtitle">"Overcoming Challenges, Achieving Success"</span></h5>
        <p>We provide remedial classes to help students overcome academic challenges and achieve their full potential.
          Additionally, job-oriented and skill enhancement courses are available to equip students with practical skills
          and knowledge required for the job market, ensuring they are career-ready upon graduation.</p>
      </div>

    </div>

    <!-- Closing Statement -->
    <p class="bp-closing mt-4">
      Our college's best practices are a testament to our dedication to producing well-rounded individuals who are not
      only academically proficient but also socially responsible and morally upright. Through these initiatives, we
      strive to create a nurturing environment that supports the growth and success of every student.
    </p>

  </div>
</div>
